import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type GetWorkflowActionsQueryVariables = GraphQLTypes.Exact<{ [key: string]: never }>;

export type GetWorkflowActionsQueryResult = { __typename?: 'Query' } & {
  workflowActions: Array<{ __typename?: 'WorkflowAction' } & Pick<GraphQLTypes.WorkflowAction, 'label' | 'path' | 'type'>>;
};

export const GetWorkflowActionsDocument = /*#__PURE__*/ gql`
  query getWorkflowActions {
    workflowActions {
      label
      path
      type
    }
  }
`;

/**
 * __useGetWorkflowActionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowActionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowActionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetWorkflowActionsQueryResult, GetWorkflowActionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<GetWorkflowActionsQueryResult, GetWorkflowActionsQueryVariables>(GetWorkflowActionsDocument, options);
}
export function useGetWorkflowActionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowActionsQueryResult, GetWorkflowActionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<GetWorkflowActionsQueryResult, GetWorkflowActionsQueryVariables>(
    GetWorkflowActionsDocument,
    options
  );
}
export type GetWorkflowActionsQueryHookResult = ReturnType<typeof useGetWorkflowActionsQuery>;
export type GetWorkflowActionsLazyQueryHookResult = ReturnType<typeof useGetWorkflowActionsLazyQuery>;
